import type { InterventionTaskViewModel, FullVisitViewModel, WorkflowStageTaskViewModel, OasisTaskViewModel } from '@generated';

export function flattenWorkflowStageTasksFromVisit(visit: FullVisitViewModel): WorkflowStageTaskViewModel[] {
	return visit.visitBuckets
		.filter(x => x.orderedItems.length > 0)
		.flatMap(x => x.orderedItems.filter(x => x.workflowStageTaskBucket))
		.map(x => x.workflowStageTask!);
}

export function flattenInterventionTasksFromVisit(visit: FullVisitViewModel): InterventionTaskViewModel[] {
	return visit.visitBuckets
		.filter(x => x.orderedItems.length > 0)
		.flatMap(x => x.orderedItems.filter(x => x.interventionTaskBucket))
		.flatMap(x => (x.category ? x.category.interventionTasks : [x.interventionTask!]));
}

export function flattenOasisTasksFromVisit(visit: FullVisitViewModel): OasisTaskViewModel[] {
	return visit.visitBuckets
		.filter(x => x.orderedItems.length > 0)
		.flatMap(x => x.orderedItems.filter(x => x.oasisTaskBucket))
		.flatMap(x => (x.category ? x.category.oasisTasks : [x.oasisTask!]));
}
